export async function fetchGetAuth(url) {
    try {
        const res = await fetch(url, {
            credentials: "include",
        });

        if (res && res.ok) {
            const resJson = await res.json();
            return resJson;
        }
        else {
            throw new Error(`faild to fetch json url: ${url} with status: ${res && res.status}`)
        }
    }
    catch (err) {
        console.log("error in fetch json", url, err);
    }
}

export async function fetchStaticJson(url) {
    let notCacheNumber;
    let res;
    let link;
    try {
        notCacheNumber = Math.floor(Date.now());
        link = `${url}?ver=${notCacheNumber}`
        res = await fetch(link)

        if (res && res.ok) {
            const resJson = await res.json();
            return resJson;
        }
        else {
            throw new Error(`failed to fetch json url: ${url} with status: ${res && res.status}`);
        }
    }
    catch (err) {
        console.log("error in fetch json", url, err);
        let text, json;
        if (res) {
            try {
                text = await res.text();
                json = await res.json();
            }
            catch (e) {

            }
        }
        const msg = `${err.message} status ${res?.status} link: ${link} text: ${text} json: ${json}`;
        console.log('msg', msg)
    }
}

export async function postJson(url, data) {
    let res, resJson;
    try {
        res = await fetch(
            url, {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json'
            },
            body: data && JSON.stringify(data)
        });

        if (res) {
            resJson = await res.json();
            return {
                status: res.status,
                body: resJson,
                ok: res.ok
            };
        }
        else {
            throw new Error(`status from api ${res.status}`)
        }
    }
    catch (err) {
        console.error("error in postJson", url, err);
        return {
            status: res?.status,
            body: resJson,
            ok: res?.ok
        };
    }

}


export async function fetchGet(url, data) {
    let res, resJson;
    try {
        res = await fetch(
            url, {
            method: 'Get',
            credentials: "include"
        });

        if (res) {
            resJson = await res.json();
            return {
                status: res.status,
                body: resJson,
                ok: res.ok
            };
        }
        else {
            throw new Error(`status from api`)
        }
    }
    catch (err) {
        console.error("error in postJson", url, err);
        return {
            status: res?.status,
            body: resJson,
            ok: res?.ok,
            error: err
        };
    }
}

export async function postForm(url, formData) {
    let res, resJson;
    try {
        res = await fetch(url, {
            method: 'POST',
            credentials: "include",
            body: formData
        });

        if (res) {
            try {
                resJson = await res.json();
            } catch (err) {
                console.log("error", err);
                resJson = null;
            }

            return {
                status: res.status,
                body: resJson,
                ok: res.ok
            };
        } else {
            throw new Error(`status from api ${res?.status}`)
        }
    } catch (err) {
        console.error("error in postForm", url, err);
        return {
            status: res?.status,
            body: resJson,
            ok: res?.ok
        };
    }
}

export const toFormData = (obj, formData = new FormData(), prefix = '') => {
    for (const [key, value] of Object.entries(obj)) {
        const fieldName = prefix ? `${prefix}.${key}` : key;

        if (value === null || value === undefined) continue;
        if (value instanceof Date)
            formData.append(fieldName, value.toISOString());
        if (value instanceof File || value instanceof Blob) {
            formData.append(fieldName, value);
            if (value instanceof Date) {
                formData.append(fieldName, value.toISOString());
            }
        } else if (Array.isArray(value)) {
            value.forEach((item, index) => {
                const arrayPrefix = `${fieldName}[${index}]`;
                if (typeof item === 'object' && !(item instanceof File)) {
                    toFormData(item, formData, arrayPrefix);
                } else {
                    formData.append(arrayPrefix, item ?? '');
                }
            });
        } else if (typeof value === 'object') {
            toFormData(value, formData, fieldName);
        } else {
            formData.append(fieldName, value);
        }
    }
    return formData;
}

export const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));


export const base64ToFile = (base64, filename, mimeType) => {
    const byteString = atob(base64);
    const ab = new ArrayBuffer(byteString?.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString?.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: mimeType });
    return new File([blob], filename, { type: mimeType });
};


export const getSectionsByEndpoints = (providers, providerName, endpoints) => {
    const provider = providers.find(provider => provider.name === providerName);
    return [...new Set(Object.keys(provider.endpoints).filter(key => endpoints.includes(key)).flatMap(key => provider.endpoints[key].sections))];
}

export const getDaysDiff = (fromDate, toDate = new Date()) => {
    const fromDateDiff = new Date(fromDate).getTime();
    const toDateDiff = new Date(toDate).getTime();
    const daysDiff = Math.ceil((fromDateDiff - toDateDiff) / (1000 * 60 * 60 * 24))
    return daysDiff - 1;
}

export const isDateOnOrAfter = (currentDate, targetDate) => {
    if (!currentDate || !targetDate) return false;

    const current = new Date(currentDate);
    const target = new Date(targetDate);

    current.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);

    return current >= target;
}


export const isDateBetween = (startDate, currentDate, endDate) => {
    if (!currentDate || !startDate || !endDate) return false;

    const current = new Date(currentDate);
    const start = new Date(startDate);
    const end = new Date(endDate);

    current.setHours(0, 0, 0, 0);
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    return current >= start && current <= end;
}

export const gradeTextAllLangMap = {
    1: ["1", "א", "אחת", "first", "grade 1", "الصف الأول", "1st"],
    2: ["2", "ב", "שתיים", "second", "grade 2", "الصف الثاني", "2nd"],
    3: ["3", "ג", "שלוש", "third", "grade 3", "الصف الثالث", "3rd"],
    4: ["4", "ד", "ארבע", "fourth", "grade 4", "الصف الرابع", "4th"],
    5: ["5", "ה", "חמש", "fifth", "grade 5", "الصف الخامس", "5th"],
    6: ["6", "ו", "שש", "sixth", "grade 6", "الصف السادس", "6th"],
    7: ["7", "ז", "שבע", "seventh", "grade 7", "الصف السابع", "7th"],
    8: ["8", "ח", "שמונה", "eighth", "grade 8", "الصف الثامن", "8th"],
    9: ["9", "ט", "תשע", "ninth", "grade 9", "الصف التاسع", "9th"],
    10: ["10", "י", "עשר", "tenth", "grade 10", "الصف العاشر", "10th"],
    11: ["11", "יא", "אחת עשרה", "eleventh", "grade 11", "الصف الحادي عشر", "11th"],
    12: ["12", "יב", "שתיים עשרה", "twelfth", "grade 12", "الصف الثاني عشر", "12th"]
};

export const getClassByNum = (num) => {
    return ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ז', 'ח', 'ט', 'י', 'יא', 'יב'][num - 1];
}

export const days = ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש'];

export const monthsAllLang = [
    { he: 'ינואר', ar: 'يناير' },
    { he: 'פברואר', ar: 'فبراير' },
    { he: 'מרץ', ar: 'مارس' },
    { he: 'אפריל', ar: 'أبريل' },
    { he: 'מאי', ar: 'مايو' },
    { he: 'יוני', ar: 'يونيو' },
    { he: 'יולי', ar: 'يوليو' },
    { he: 'אוגוסט', ar: 'أغسطس' },
    { he: 'ספטמבר', ar: 'سبتمبر' },
    { he: 'אוקטובר', ar: 'أكتوبر' },
    { he: 'נובמבר', ar: 'نوفمبر' },
    { he: 'דצמבר', ar: 'ديسمبر' }
];

export const getUserAllSchoolProperty = (userDetails, property) => {
    if (!userDetails)
        return null;
    return userDetails.schools ?
        userDetails.schools.map(s => s[property])
        :
        userDetails.defaultSchool?.[property] ? [userDetails.defaultSchool?.[property]] : null;
}

export const isOnlyKosherUser = (userDetails) => {
    //זה הקוד התקין
    //מכיוון שאנו רוצים להיות זהים לביס ישן אנו רוצים לעשות את אותה פונקצינאליות
    // const superVision = userDetails.defaultSchool?.supervisionId;
    // return (superVision === 3 || superVision === '3');
    const superVisions = getUserAllSchoolProperty(userDetails, 'supervisionId');
    if (Array.isArray(superVisions) && superVisions?.length > 0) {
        const hasNonKosherSchool = superVisions.some(s => s !== 3 && s !== '3');
        if (hasNonKosherSchool)
            return false;
        return true;
    }
    return (superVisions === 3 || superVisions === '3');
}

export const usersInOldAppFunc = (isStudent, user, userDetails) => {
    return (
        !user ||
        !isStudent ||
        (window.config.oldVirtualCampusAppStudentsClasses && window.config.oldVirtualCampusAppStudentsClasses?.includes(parseInt(user?.studentkita))) ||
        (window.config.lockedAppToCharediUsers && isOnlyKosherUser(userDetails))
    )
}
export const getHiddenFromUsersConfig = (isStudent) => {
    if (typeof isStudent !== "boolean")
        return null;
    const typeUser = isStudent ? "student" : "teacher";
    const config = window.config?.hiddenFromUsers?.[typeUser];
    if (!config || config.tags == null)
        return null;
    return config;
};

export const shouldHideByTagsFromUsers = (item, hidden) => {
    if (!hidden?.tags)
        return false;
    return (item.tags || []).some(tag => hidden.tags.includes(tag));
};

export const teacherInOldAppFunc = (isStudent, user, userDetails) => {
    const wl = window.config?.AllowNewAppTeacherList || [];
    return (
        !user ||
        (window.config.lockedAppToCharediUsers && isOnlyKosherUser(userDetails)) ||
        (window.config.lockedAppToCharediTeachers && !wl.includes(user?.exidentifier))
    )
}

export const openInNewTab = (src) => {
    window.open(src, "_blank");
};

export const appendQueryParams = (url, params = {}) => {
    if (!url)
        return url;
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value != null && value !== "")
            searchParams.set(key, value);
    });
    const qs = searchParams.toString();
    if (!qs)
        return url;
    return `${url}${url.includes("?") ? "&" : "?"}${qs}`;
};

export const formatHebrewDateTime = (dateString) => {
    if (!dateString)
        return "";
    return new Date(dateString)
        .toLocaleString("he-IL", {
            day: "2-digit",
            month: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        }).replace(",", "");
};

export const getObjectByKey = (key, list) => {
    if (!Array.isArray(list)) return null;
    return list.find(item => item.key === key) || null;
};


export const hasLocalStorageKey = (key) => {
    if (!key)
        return false;
    const isExistInLocalStorage = localStorage.getItem(key);

    if (!isExistInLocalStorage) {
        localStorage.setItem(key, "true");
        return true;
    }

    return false;
}

export const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('-');
    if (!year || !month || !day) return '';
    const shortYear = year.slice(-2);
    const dayNum = parseInt(day, 10);
    const monthNum = parseInt(month, 10);
    return `${dayNum}.${monthNum}.${shortYear}`;

};

export const formatISODateDDMMYYYY = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    return `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.${d.getFullYear()}`;
};

export const formatDateToYYYYMMDD = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return isNaN(date.getTime()) || date.getFullYear() <= 1
        ? null
        : `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

export const mapEventToCalendar = (event) => ({
    Id: event.courseExternalId,
    Subject: event.title,
    StartTime: event.allDayEvent ? new Date(event.date) : new Date(event.from),
    EndTime: event.allDayEvent ? new Date(event.date) : new Date(event.to),
    Date: new Date(event.date),
    Description: event.description,
    Location: event.location,
    Link: event.link,
    IsAllDay: event.allDayEvent,
    Repeat: event.Repeat,
    ProviderName: event.providerName,
    ProviderDescription: event.providerDescription,
    ProviderColor: event.ProviderColor,
    ProviderLogo: event.providerLogo,
    Domain: event.domain,
    DomainColor: event.domainColor,
    Picture: event.picture,
    Teachers: event.teachers,
    ...event,
});
export const startOfToday = () => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
};

export const parseValidDate = (v) => {
    if (!v) return null;
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? null : d;
};

export const parseJsonValue = (value, fallback = null) => {
    if (value == null || value === "")
        return fallback;
    if (typeof value === "object")
        return value;
    try {
        return JSON.parse(value);
    } catch {
        return fallback;
    }
};

export const isRouteShouldFetch = () => {
    const noFetchRouters = window.config?.noFetchRouters ?? [];
    return !noFetchRouters.some(route => window.location.pathname.includes(route));
};


export const getRedirectUrlToOldApp = (location) => {
    const base = (window.config.oldVirtualCampusUrl || '').replace(/\/$/, '');
    const path = location.pathname || '/';
    return base + path + location.search + location.hash;
};

export function getDeepValue(obj, path) {
    if (!obj || !path || typeof path !== "string")
        return undefined;
    const normalizedPath = path.replace(/\[(\d+)\]/g, ".$1");
    return normalizedPath.split(".").reduce((acc, key) => acc?.[key], obj);
}

export const enrichSchoolWithNotebookLink = (school) => {
    if (!school)
        return school;
    return {
        ...school,
        notebookLmLink: school.mailLink ? school.mailLink.replace("mail.google.com", "notebooklm.google.com") : null
    };
};
export const getClassLabelKey = (num) => {
    return `class${num}`;
};

export const getHomeroomClassDisplayString = (mainClass, texts) => {
    return mainClass != null ? `${texts[getClassLabelKey(mainClass.class)] ?? ""}${" "}${mainClass.ordinal}` : "";
};

export const htmlPlainTextLength = (html = "") => {
    if (!html)
        return 0;
    const temp = document.createElement("div");
    temp.innerHTML = html;
    const text = temp.textContent || temp.innerText || "";
    return text.length;
};

export const compressImage = (file, maxWidth = 800, maxHeight = 800, quality = 0.7, fileName = file.name) => {

    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
            const img = new Image();

            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");

                let width = img.width;
                let height = img.height;

                if (width > maxWidth || height > maxHeight) {
                    if (width > height) {
                        height = (maxWidth / width) * height;
                        width = maxWidth;
                    } else {
                        width = (maxHeight / height) * width;
                        height = maxHeight;
                    }
                }
                canvas.width = width;
                canvas.height = height;

                ctx.fillStyle = "white";
                ctx.fillRect(0, 0, width, height);
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob(
                    (blob) => {
                        if (!blob) {
                            reject(new Error("Compression failed"));
                            return;
                        }

                        resolve(
                            new File([blob], fileName, {
                                type: "image/jpeg",
                            })
                        );
                    },
                    "image/jpeg",
                    quality
                );
            };
            img.onerror = () => reject(new Error("Error loading image"));
            img.src = event.target.result;
        };
        reader.onerror = () => reject(new Error("Error reading file"));
        reader.readAsDataURL(file);
    });
};

export const formatSaveDate = (date) => {
    if (!date) return null;
    const d = date instanceof Date ? date : new Date(date);
    return `${d.getDate()}.${d.getMonth() + 1}.${String(d.getFullYear()).slice(-2)}`;
};

export const getInitials = (firstName, lastName) => {
    const first = firstName?.[0] ?? "";
    const last = lastName?.[0] ?? "";
    return `${first}.${last}`;
};

export function resolveBucketImageSrc(imageFile) {
    if (!imageFile) return null;

    if (imageFile instanceof File) {
        return URL.createObjectURL(imageFile);
    }

    if (typeof imageFile !== "string")
        return null;

    if (imageFile.startsWith("data:") || imageFile.startsWith("http")) {
        return imageFile;
    }

    const bucketBase = window.config?.bucketFilesUrl?.replace(/\/$/, "") ?? "";

    if (imageFile.startsWith("/"))
        return `${bucketBase}${imageFile}`;

    // נתיב יחסי ב-bucket, למשל messages/abc.jpg
    if (imageFile.includes("/"))
        return `${bucketBase}/${imageFile}`;

    return `data:image/png;base64,${imageFile}`;
}

export const isValidUrl = (value) => {
    try {
        const parsed = new URL(value);
        return parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch {
        return false;
    }
};